import React, { useState } from 'react'
import { Button, Checkbox, ListItemIcon, ListItemText, Menu, MenuItem, SxProps, Theme } from '@mui/material'
import { useToggleableFeatureFlags } from './FeatureFlagProvider'

type Props = { buttonSx?: SxProps<Theme> }

/**
 * Top bar menu listing the dashboard experiments the signed-in coach may switch on or off for
 * themselves: every soft-launched one, plus the pilots they are part of. Renders nothing when
 * there is nothing to toggle.
 */
export default function FeatureFlagMenu({ buttonSx }: Props) {
  const { toggleableFlags, setFeatureFlag } = useToggleableFeatureFlags()
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)

  if (toggleableFlags.length === 0) {
    return null
  }

  return (
    <>
      <Button color="inherit" onClick={(event) => setAnchorEl(event.currentTarget)} sx={buttonSx}>
        Experiments
      </Button>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        {toggleableFlags.map((flag) => (
          <MenuItem key={flag.key} onClick={() => setFeatureFlag(flag.key, !flag.enabled)}>
            <ListItemIcon>
              <Checkbox edge="start" checked={flag.enabled} tabIndex={-1} disableRipple />
            </ListItemIcon>
            <ListItemText primary={flag.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
